<div class="bg-white flex flex-col gap-4 p-4 border border-gray-200 rounded-lg">
  <!-- BERICHTSSTRUKTUR -->
  <div class="flex flex-col gap-1 pt-2 pb-1">
    <span class="text-[11px] font-medium text-gray-400 uppercase">Berichtsstruktur</span>
    <div class="border-b border-gray-200"></div>
  </div>
  <span class="text-xs text-gray-500">Einstellungen zur Berichtsstruktur werden pro myCheck getroffen.</span>

  @if (loading) {
    <span class="text-sm text-gray-500">myChecks werden geladen...</span>
  } @else if (reportRulesets.length === 0) {
    <div class="flex items-center gap-2 px-3 py-2 bg-gray-100 rounded-lg">
      <fa-icon [icon]="faCircleInfo" class="text-gray-500 text-xs shrink-0"></fa-icon>
      <span class="text-sm font-medium text-gray-500">Wähle im Schritt „Regelauswahl“ mindestens ein myCheck, um die Berichtsstruktur zu konfigurieren.</span>
    </div>
  } @else {
    <!-- Set-Tabs -->
    <div class="flex flex-wrap items-center gap-x-6 border-b border-gray-200">
      @for (rs of reportRulesets; track rs.id; let i = $index) {
        <button
          (click)="selectRulesetTab(i)"
          [class]="i === activeRulesetIndex ? 'border-gray-900' : 'border-transparent'"
          class="flex items-center gap-2 pb-1 -mb-px border-b-2 transition-colors"
          type="button">
          <span
            [class]="i === activeRulesetIndex ? 'bg-gray-900 text-white' : 'bg-gray-50 text-gray-500'"
            class="flex items-center justify-center w-4 h-4 rounded-full text-[12px] font-semibold">
            {{ i + 1 }}
          </span>
          <span
            [class]="i === activeRulesetIndex ? 'text-gray-900' : 'text-gray-500'"
            class="text-sm">{{ rs.name }}</span>
          @if (i === activeRulesetIndex) {
            <span class="px-2.5 py-0.5 rounded-md bg-blue-100 text-gray-700 text-xs font-medium">
              {{ getTypeBadgeLabel(rs.type) }}
            </span>
          }
        </button>
      }
    </div>

    <!-- Konfiguration des aktiven Sets -->
    @if (activeRuleset; as ruleset) {
    <div class="flex flex-col gap-4 main-sm:flex-row main-sm:items-start">
        @if (showsPerspective(ruleset)) {
          <div class="flex flex-1 flex-col gap-1 min-w-0">
            <bic-select (valueChange)="updateOrdering($event)"
                        [label]="'Berichtsperspektive'"
                        [placeholder]="'Berichtsperspektive auswählen'"
                        [value]="activeOrderingValue">
              @for (option of orderingOptions; track option.value) {
                <bic-dropdown-element [value]="option.value"><span>{{ option.label }}<span
                  class="text-gray-400">{{ option.hintSuffix }}</span></span></bic-dropdown-element>
              }
            </bic-select>
            <span class="text-xs text-gray-500 leading-[1.5]">Reihenfolge der Berichtsspalten (Ergebnis immer
              zuletzt). Anzahl der Spalten ergibt sich aus der Prüfebene des Regelsets.</span>
            @if (isCombinedCheck) {
              <!-- Erklärt die einzige verbleibende Option: im gemeinsamen Lauf gibt es kein Ergebnis
                   je Datei, deshalb steht die Dateiebene nicht zur Wahl. -->
              <span class="text-xs text-gray-500 leading-[1.5]">Dieses Regelset prüft alle Dateien
                zusammen – der Bericht hat deshalb keine Dateiebene.</span>
            }
          </div>
        }
        <div class="flex flex-col gap-1">
          @if (showsPerspective(ruleset)) {
            <span aria-hidden="true" class="invisible select-none text-sm font-medium leading-normal">&nbsp;</span>
          }
          <bic-button (onClick)="openColumnEditor()" buttonType="white">
            <fa-icon [icon]="faSliders" class="text-sm mr-2"></fa-icon>
            Anzeigewerte Bearbeiten
          </bic-button>
        </div>
      </div>
    }
  }

  <!-- AUSGABEFORMATE -->
  <div class="flex flex-col gap-1 pt-2 pb-1">
    <span class="text-[11px] font-medium text-gray-400 uppercase">Ausgabeformate</span>
    <div class="border-b border-gray-200"></div>
  </div>
  <div class="grid grid-cols-1 gap-4 main-md:grid-cols-3">
    <!-- Excel-Export -->
    <div class="flex items-center justify-between gap-4 p-4 rounded-lg border border-gray-200">
      <div class="flex items-center gap-3 min-w-0">
        <fa-icon [icon]="faFileExcel" [class]="state.excelExport ? 'text-gray-500' : 'text-gray-300'" class="text-lg shrink-0"></fa-icon>
        <div class="flex flex-col min-w-0">
          <span class="text-sm font-medium text-gray-900">Excel-Export</span>
          <span class="text-xs text-gray-500">Tabellarische Ausgabe der Ergebnisse</span>
        </div>
      </div>
      <bic-toggle (ngModelChange)="toggleExcelExport()" [ngModel]="state.excelExport" [disabled]="true"
                  tooltip="Demnächst verfügbar" tooltipDirection="left"></bic-toggle>
    </div>

    <!-- PDF-Export -->
    <div class="flex items-center justify-between gap-4 p-4 rounded-lg border border-gray-200">
      <div class="flex items-center gap-3 min-w-0">
        <fa-icon [icon]="faFilePdf" [class]="state.pdfExport ? 'text-gray-500' : 'text-gray-300'" class="text-lg shrink-0"></fa-icon>
        <div class="flex flex-col min-w-0">
          <span class="text-sm font-medium text-gray-900">PDF-Export</span>
          <span class="text-xs text-gray-500">Bericht als PDF-Datei herunterladbar</span>
        </div>
      </div>
      <bic-toggle (ngModelChange)="togglePdfExport()" [ngModel]="state.pdfExport" [disabled]="true"
                  tooltip="Demnächst verfügbar" tooltipDirection="left"></bic-toggle>
    </div>

    <!-- BCF-Export -->
    <div class="flex items-center justify-between gap-4 p-4 rounded-lg border border-gray-200">
      <div class="flex items-center gap-3 min-w-0">
        <fa-icon [icon]="faClipboardCheck" [class]="state.bcfExport ? 'text-gray-500' : 'text-gray-300'" class="text-lg shrink-0"></fa-icon>
        <div class="flex flex-col min-w-0">
          <span class="text-sm font-medium text-gray-900">BCF-Export</span>
          <span class="text-xs text-gray-500">Nur verfügbar bei Prüfung von IFC-Modellen</span>
        </div>
      </div>
      <bic-toggle (ngModelChange)="toggleBcfExport()" [ngModel]="state.bcfExport" [disabled]="true"
                  tooltip="Demnächst verfügbar" tooltipDirection="left"></bic-toggle>
    </div>
  </div>

  <!-- VERTEILUNG & ABLAGE -->
  <div class="flex flex-col gap-1 pt-2 pb-1">
    <span class="text-[11px] font-medium text-gray-400 uppercase">Verteilung & Ablage</span>
    <div class="border-b border-gray-200"></div>
  </div>
  <div class="flex flex-col gap-4">
    <!-- Task in Aufgaben erstellen -->
    <div class="flex flex-col rounded-lg border border-gray-200">
      <div class="flex items-center justify-between gap-4 p-4" [class.border-b]="state.createTask" [class.border-gray-200]="state.createTask">
        <div class="flex items-center gap-3 min-w-0">
          <fa-icon [icon]="faClipboardCheck" [class]="state.createTask ? 'text-gray-500' : 'text-gray-300'" class="text-lg shrink-0"></fa-icon>
          <div class="flex flex-col min-w-0">
            <span class="text-sm font-medium text-gray-900">Task in Aufgaben erstellen</span>
            <span class="text-xs text-gray-500">Automatisches Aufgaben-Ticket nach Prüfung</span>
          </div>
        </div>
        <bic-toggle (ngModelChange)="toggleCreateTask()" [ngModel]="state.createTask" [disabled]="true"
                    tooltip="Demnächst verfügbar" tooltipDirection="left"></bic-toggle>
      </div>
      @if (state.createTask) {
        <div class="flex flex-col gap-4 p-4 main-sm:flex-row">
          <div class="flex flex-1 flex-col gap-1 min-w-0">
            <bic-select (valueChange)="updateTaskCreationLevel($event)"
                        [label]="'Ebene zur Aufgabenerstellung'"
                        [placeholder]="'Ebene auswählen'"
                        [value]="state.taskCreationLevel">
              @for (option of taskLevelOptions; track option.value) {
                <bic-dropdown-element [value]="option.value">{{ option.label }}</bic-dropdown-element>
              }
            </bic-select>
          </div>
          <div class="flex flex-1 flex-col gap-1 min-w-0">
            <bic-input (valueChange)="updateTaskNamePrefix($event)"
                       [label]="'Präfix für Name der Aufgabe'"
                       [placeholder]="'z. B. „myCheck_Aufgabe: “'"
                       [value]="state.taskNamePrefix">
            </bic-input>
          </div>
        </div>
      }
    </div>

    <!-- Bericht in Projektordner ablegen -->
    <div class="flex flex-col rounded-lg border border-gray-200">
      <div class="flex items-center justify-between gap-4 p-4" [class.border-b]="state.storeInProjectFolder" [class.border-gray-200]="state.storeInProjectFolder">
        <div class="flex items-center gap-3 min-w-0">
          <fa-icon [icon]="faFolderOpen" [class]="state.storeInProjectFolder ? 'text-gray-500' : 'text-gray-300'" class="text-lg shrink-0"></fa-icon>
          <div class="flex flex-col min-w-0">
            <span class="text-sm font-medium text-gray-900">Bericht in Projektordner ablegen</span>
            <span class="text-xs text-gray-500">Automatische Archivierung</span>
          </div>
        </div>
        <bic-toggle (ngModelChange)="toggleStoreInProjectFolder()" [ngModel]="state.storeInProjectFolder" [disabled]="true"
                    tooltip="Demnächst verfügbar" tooltipDirection="left"></bic-toggle>
      </div>
      @if (state.storeInProjectFolder) {
        <div class="flex flex-col gap-4 p-4">
          <!-- Zielordner -->
          <bic-input (valueChange)="updateTargetFolder($event)"
                     [label]="'Zielordner'"
                     [placeholder]="'/projekt/berichte/brandschutz'"
                     [value]="state.reportTargetFolder">
          </bic-input>

          <!-- Dateiname-Muster -->
          <div class="flex flex-col gap-2">
            <bic-input (valueChange)="updateFileNamePattern($event)"
                       [label]="'Dateiname-Muster'"
                       [placeholder]="'{Projekt}_{Datum}_Brandschutz'"
                       [value]="state.reportFileNamePattern">
            </bic-input>
            <div class="flex flex-wrap items-center gap-2">
              @for (token of fileNameTokens; track token) {
                <button (click)="appendFileNameToken(token)"
                        class="px-2.5 py-0.5 rounded-md bg-gray-200 text-gray-700 text-xs font-medium hover:bg-gray-300 transition-colors"
                        type="button">
                  {{ token }}
                </button>
              }
            </div>
            <span class="text-sm text-gray-500">Vorschau:&nbsp;&nbsp; {{ fileNamePreview }}</span>
          </div>
        </div>
      }
    </div>

    <!-- E-Mail Benachrichtigung -->
    <div class="flex flex-col rounded-lg border border-gray-200">
      <div class="flex items-center justify-between gap-4 p-4" [class.border-b]="state.emailNotification" [class.border-gray-200]="state.emailNotification">
        <div class="flex items-center gap-3 min-w-0">
          <fa-icon [icon]="faUsers" [class]="state.emailNotification ? 'text-gray-500' : 'text-gray-300'" class="text-lg shrink-0"></fa-icon>
          <div class="flex flex-col min-w-0">
            <span class="text-sm font-medium text-gray-900">E-Mail Benachrichtigung</span>
            <span class="text-xs text-gray-500">Automatische Benachrichtigung der Prüfung mit Bericht Export</span>
          </div>
        </div>
        <bic-toggle (ngModelChange)="toggleEmailNotification()" [ngModel]="state.emailNotification" [disabled]="true"
                    tooltip="Demnächst verfügbar" tooltipDirection="left"></bic-toggle>
      </div>
      @if (state.emailNotification) {
        <div class="flex flex-col gap-4 p-4 main-sm:flex-row">
          <!-- Projektmitglieder. Im Admin-Modus (projektlos) gibt es keine – das Feld bliebe leer
               und würde Rätsel aufgeben, deshalb ausgeblendet. Externe Adressen bleiben nutzbar. -->
          @if (projectId) {
            <div class="flex flex-1 flex-col gap-1 min-w-0">
              <bic-select (valueChange)="updateNotificationMembers($event)"
                          [label]="'Benachrichtigung an Projektmitglieder'"
                          [multiple]="true"
                          [placeholder]="'Projektmitglieder auswählen'"
                          [value]="state.notificationMemberIds">
                @for (member of projectMembers; track member.id) {
                  <bic-dropdown-element [selection]="true" [value]="member.id">{{ getMemberLabel(member) }}
                  </bic-dropdown-element>
                }
              </bic-select>
            </div>
          }
          <!-- Externe Mail-Adressen -->
          <div class="flex flex-1 flex-col gap-1 min-w-0">
            <bic-input (valueChange)="updateRecipients($event)"
                       [label]="'Benachrichtigung an externe Mail-Adressen'"
                       [placeholder]="'musterfrau@musterunternehmen.de'"
                       [value]="recipientsString">
            </bic-input>
          </div>
        </div>
      }
    </div>
  </div>
</div>

<!-- Popup: Anzeigewerte im Bericht anpassen -->
@if (showColumnEditor && editingConfig) {
  <bic-popup (close)="closeColumnEditor()" [title]="'Anzeigewerte im Bericht anpassen'" customClass="w-[698px]">
    <div bicPopupContent class="flex flex-col gap-6">
      <!-- Ebenen-Auswahl -->
      <div class="flex w-fit overflow-hidden rounded-lg border border-gray-200">
        @for (level of editingConfig.levels; track level.key; let i = $index) {
          <button
            (click)="selectEditingLevel(level.key)"
            [class]="level.key === editingLevelKey ? 'bg-gray-100 text-gray-900' : 'bg-white text-gray-500 hover:bg-gray-50'"
            class="px-3 py-2 text-sm font-medium border-r border-gray-200 last:border-r-0 transition-colors"
            type="button">
            {{ i + 1 }}. Ebene: {{ level.label }}
          </button>
        }
      </div>

      <!-- Überschrift der aktiven Ebene -->
      <bic-input [value]="editingLevelLabel" (valueChange)="updateEditingLevelLabel($event)"
                 [label]="'Überschrift der Ebene'" [showX]="false"
                 placeholder="Überschrift"></bic-input>

      <!-- Struktur-Identifikator: welcher Set-Eingabeparameter als Identifikator-Spalte dient -->
      @if (editingLevelKey === 'structure') {
        <bic-select (valueChange)="updateStructureIdentifikator($event)"
                    [label]="'Identifikator (aus myCheck)'"
                    [placeholder]="'Eingabeparameter auswählen'"
                    [value]="editingStructureIdentifikatorParamId ?? ''">
          @for (param of structureIdentifikatorOptions; track param.id) {
            <bic-dropdown-element [value]="param.id">{{ param.name }}</bic-dropdown-element>
          }
        </bic-select>
      }

      <!-- Spalten der aktiven Ebene: Reihenfolge per Drag (Status fix erste Position, detail fix) -->
      <div (cdkDropListDropped)="dropColumn($event)" cdkDropList [cdkDropListDisabled]="!isEditingLevelReorderable"
           class="flex flex-col gap-3">
        @for (col of editingLevelColumns; track col.key; let i = $index) {
          <div cdkDrag [cdkDragDisabled]="!isColumnDraggable(col)"
               class="group flex items-center gap-3 px-4 py-2 rounded-lg border border-gray-200 bg-white">
            @if (isColumnDraggable(col)) {
              <fa-icon [icon]="faGripDotsVertical" cdkDragHandle class="text-gray-400 cursor-move"></fa-icon>
            } @else {
              <span class="w-4 shrink-0"></span>
            }
            <span [class]="col.visible ? 'text-gray-900' : 'text-gray-300'" class="flex-1 text-sm">
              {{ col.label }}@if (!col.visible) {<span class="ml-1 text-gray-300">(ausgeblendet)</span>}
            </span>
            @if (!isColumnVisibilityLocked(col)) {
              <button (click)="toggleColumnVisibility(i)"
                      [class]="col.visible ? 'opacity-0 group-hover:opacity-100' : 'opacity-100'"
                      class="flex items-center justify-center w-6 h-6 transition-opacity" type="button">
                <fa-icon [icon]="col.visible ? faEye : faEyeSlash" class="text-gray-500 text-sm"></fa-icon>
              </button>
            } @else {
              <span class="w-6 shrink-0"></span>
            }
          </div>
        }
      </div>
    </div>

    <div bicPopupButtonGroup class="flex flex-row justify-end gap-4">
      <bic-button (onClick)="closeColumnEditor()" buttonType="white">Abbrechen</bic-button>
      <bic-button (onClick)="applyColumnEditor()" buttonType="primary">Übernehmen</bic-button>
    </div>
  </bic-popup>
}

